import React from 'react';
import { Button as Button$1, OverlayTrigger, Tooltip } from 'react-bootstrap';
import { classNames } from '../../utils/class-names.js';
import { BmUIKitConfig } from '../../utils/config.js';

const Button = /*#__PURE__*/ React.forwardRef(({ href, as = href ? "a" : undefined, className, variant = "primary", rounded = false, icon = rounded ? "?" : "", iconPosition = "start", children, outlined = false, onClick, target, download, title, ...props }, ref)=>{
    const iconOnly = rounded || !children && !!icon;
    const classes = classNames(iconOnly && "btn-icon-only", rounded && "btn-rounded-circle", !iconOnly && icon && `btn-icon-${iconPosition}`, className);
    const variantAlias = outlined ? `outline-${variant}` : variant;
    const linkParams = BmUIKitConfig.getOption("customLinkProvider")({
        onClick,
        href,
        target,
        download
    });
    const button = /*#__PURE__*/ React.createElement(Button$1, {
        ref: ref,
        as: as,
        className: classes,
        variant: variantAlias,
        "data-testid": props.id || props.name,
        "aria-label": typeof title === "string" ? title : undefined,
        ...props,
        ...linkParams
    }, icon && iconPosition === "start" && /*#__PURE__*/ React.createElement("span", {
        className: "btn-icon"
    }, icon), !rounded && children, icon && iconPosition === "end" && /*#__PURE__*/ React.createElement("span", {
        className: "btn-icon"
    }, icon));
    if (title) {
        const overlay = (overlayProps)=>/*#__PURE__*/ React.createElement(Tooltip, overlayProps, title);
        return /*#__PURE__*/ React.createElement(OverlayTrigger, {
            overlay: overlay,
            delay: iconOnly ? 250 : 2500
        }, button);
    }
    return button;
});

export { Button };
//# sourceMappingURL=Button.js.map
